var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loader',{attrs:{"wrapperStyle":_vm.wrapperStyle}}):_vm._e(),(!_vm.loading && !_vm.isEmpty)?_vm._t("default"):_vm._e(),(!_vm.loading && _vm.isEmpty)?_c('div',{staticClass:"no-records"},[_vm._v(" "+_vm._s(_vm.emptyMessage)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }